import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { initializeSandboxStorage } from 'src/app/epics/public-access/utils/data';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService  {
  constructor(private _router: Router) {}
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (localStorage.getItem('currentUser') !== null) {
      return true;
    }
    if (next.queryParams['prefer'] === '0') {
      initializeSandboxStorage();
      return true;
    }
    this._router.navigate(['/account/signin']);
    return false;
  }
}
